import { InboxCreatedDocument } from "#app/lib/data";
import {
  defineSubscription,
  type AnySubscriptionRequest,
} from "#app/lib/subscriptions/subscription-provider";
import { insertIntoConnection } from "#app/lib/data/connection-cache-utils";

// Subscription stays on core — it fires off mongo `inbox` writes from
// core's note resolver. The handler bridges the payload into apiv2's
// `Notification` cache so the inbox list reflects new entries in
// real-time. The actual row will land in postgres `notification` on the
// next note creation path that uses apiv2's createNotifications (e.g.
// when notes also migrate to apiv2 — already done in this branch, so
// new mentions create both the postgres row AND fire the legacy
// subscription if core's note path is still in use during transition).
//
// Module constant (no parameters), so registration costs nothing per render.
export const INBOX_SUBSCRIPTIONS: AnySubscriptionRequest[] = [
  defineSubscription({
    document: InboxCreatedDocument,
    onData: ({ cache }, data) => {
      const newItem = data.inboxCreated?.inbox;
      if (!newItem) return;

      // Prepend to "All" tab cache — new items are never cleared.
      insertIntoConnection(
        cache,
        "notifications",
        "NotificationEdge",
        { __typename: "Notification", inboxId: newItem.inboxId },
        {
          position: "start",
          storeFieldNameIncludes: ['"showCleared":false'],
        },
      );

      // Update both the global badge and the All tab connection count.
      if (!newItem.read) {
        cache.modify({
          fields: {
            notificationUnreadCount(existing: number = 0) {
              return existing + 1;
            },
            notifications(existing: any, { storeFieldName }: any) {
              if (!storeFieldName.includes('"showCleared":false')) return existing;
              return {
                ...existing,
                unreadCount: (existing?.unreadCount ?? 0) + 1,
              };
            },
          },
        });
      }
    },
  }),
];
